<template>
  <div class="text-center">
    <div class="showSpinner">
      <i class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i> {{ loadingText }}
    </div>
  </div>
</template>

<script>
export default {
  name: "adivare-spinner",
  props: {
    loadingText: {
      type: String,
      required: true
    },
  },
}
</script>
